<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />

        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Item Name</label>
                  <input type="text"  v-model="form.itemname"/>
                </div>
              </div>

              <div class="col-lg-12 col-sm-6 col-12">
                <div class="form-group">
                  <label>Description</label>
                  <textarea class="form-control" v-model="form.itemdescription"></textarea>
                </div>
              </div>

              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Category</label>
                    <model-list-select
                      :list="categoryListFromApi"
                      v-model="form.itemcategory"
                      option-value="categoryid"
                      option-text="categoryname"
                      placeholder="Select category"
                    >
                    </model-list-select>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Unit</label>
                  <input type="text"  v-model="form.unit"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>UnitPrice</label>
                  <b-form-input type="number"  v-model="form.unitprice"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Available</label>
                  <input type="text"  v-model="form.available"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Threshold</label>
                  <input type="text"  v-model="form.threshold"/>
                </div>
              </div>
              <div class="col-lg-12">
                <a v-on:click="postData()" class="btn btn-submit me-2">Submit</a>
                <router-link to="productlist" class="btn btn-cancel">Cancel</router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>
<script>
import { ModelListSelect } from "vue-search-select"
import axios from "axios";
export default {
  data() {
    return {
      form: {
        itemname: '',
        itemdescription: '',
        itemcategory: '',
        categoryid: '',
        unit: '0',
        unitprice:'0',
        available: '0',
        threshold: '0',
      },
      filter: true,
      id: this.$route.query.id,
      title: "Item Edit Item",
      title1: "Edit a Item",
      categoryListFromApi: [],
    };
  },
  created(){
    this.fetchCategoryListFromApi();
  },
  methods: {
    async fetchCategoryListFromApi() {
    try {
      const response = await axios.get('/v1/category');
      this.categoryListFromApi = response.data; 
    } catch (error) {
      console.error('Error fetching category list:', error);
      }
    },
    postData() {
      if (!this.form.itemname) {
        Swal.fire("Please enter the item name");
        return;
      }
      if (!this.form.itemcategory) {
        Swal.fire("Please select a category");
        return;
      }
      
      axios
      .put('/v1/items/' + this.id, this.form)
      .then(response => {
        Swal.fire("Item updated successfully");
        this.$router.push({ path: '/productlist' });
      })
      .catch(error => {
        console.log(error)
        Swal.fire(error.response.data.detail);
      });
    },
    async getProductById(id) {
      axios
      .get('/v1/items/'+id)
      .then(response => {
        this.form = response.data
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      });
    }
  },
  beforeMount() {
    this.id = this.$route.query.id
    this.getProductById(this.id);
  },
  components: {
    ModelListSelect
  },
  name: "editproduct",
};
</script>